// extracted by mini-css-extract-plugin
export default {"orderHistoryContainer":"OrderHistory_orderHistoryContainer__bE2gE"};